import { fmtFecha } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

function Campo({ label, value, sub, destacado }) {
  return (
    <div className="space-y-1">
      <p className="text-xs text-zinc-500">{label}</p>
      <p className={`text-sm font-semibold ${destacado ? "text-amber-700" : "text-zinc-900"}`}>
        {value ?? "—"}
      </p>
      {sub && <p className="text-[11px] text-zinc-400">{sub}</p>}
    </div>
  );
}

const ESTADO_BADGE = {
  aprobada: "border-emerald-200 bg-emerald-50 text-emerald-800",
  pendiente: "border-amber-200 bg-amber-50 text-amber-800",
  pendiente_confirmacion: "border-indigo-200 bg-indigo-50 text-indigo-800",
};

export default function AsuntosPropiosResumen({ asuntos, usuario }) {
  if (!asuntos?.activo) return null;

  return (
    <div className="space-y-4">
      {usuario && (
        <p className="text-xs text-amber-800/80">
          {usuario.usa_asuntos_empresa
            ? `Hereda la empresa (${usuario.dias_asuntos_propios_empresa ?? usuario.dias_asuntos_propios_efectivos ?? 0} d/año)`
            : `Personalizado: ${usuario.dias_asuntos_propios_efectivos ?? asuntos.total} d/año`}
        </p>
      )}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Campo label="Días anuales" value={asuntos.total} sub="Días laborables" />
        <Campo
          label="Días restantes"
          value={asuntos.restantes}
          sub={`de ${asuntos.total} en ${asuntos.anio || new Date().getFullYear()}`}
          destacado
        />
        <Campo
          label="Días usados"
          value={asuntos.usados}
          sub={
            asuntos.usados_ajuste
              ? `${asuntos.usados_ajuste} d. previos a la incorporación + resto en solicitudes`
              : "Asuntos propios aprobados"
          }
        />
        <Campo label="Pendientes" value={asuntos.pendientes} sub="En revisión" />
      </div>

      {asuntos.periodos?.length > 0 ? (
        <div>
          <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-zinc-500">
            Periodos ({asuntos.anio || new Date().getFullYear()})
          </p>
          <ul className="max-h-56 space-y-2 overflow-y-auto">
            {asuntos.periodos.map((p) => (
              <li
                key={p.id}
                className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-zinc-100 bg-zinc-50/80 px-3 py-2 text-sm"
              >
                <div className="min-w-0">
                  <p className="font-medium text-zinc-800">
                    {fmtFecha(p.fecha_inicio)} — {fmtFecha(p.fecha_fin)}
                  </p>
                  {p.motivo && <p className="truncate text-xs text-zinc-500">{p.motivo}</p>}
                </div>
                <div className="flex shrink-0 items-center gap-2">
                  <span className="text-xs font-medium text-zinc-600">{p.dias} d</span>
                  <Badge variant="outline" className={`text-[10px] ${ESTADO_BADGE[p.estado] || ""}`}>
                    {p.estado === "aprobada" ? "Aprobada" : p.estado === "pendiente" ? "Pendiente" : p.estado}
                  </Badge>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="rounded-lg border border-dashed border-zinc-200 py-6 text-center text-sm text-zinc-400">
          Sin asuntos propios registrados este año.
        </p>
      )}
    </div>
  );
}
